import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { SystemSettingsDto } from '../../admin/models/mojo-system-settings-model';
import { UrlBuilderService } from '../../common/services/url-builder.service';

@Injectable()
export class MojoSystemSettingsService {

  private readonly API_URL: string;

  constructor(
    private readonly http: HttpClient,
    private readonly urlBuilder: UrlBuilderService) {
    this.API_URL = this.urlBuilder.getMojoApiUrl('systemsettings');
  }

  public getSystemSettings(): Observable<SystemSettingsDto> {
    const url = `${this.API_URL}/getsystemsettings`;
    return this.http.get<SystemSettingsDto>(url);
  }

  public saveSystemSettings(settings: SystemSettingsDto): Observable<string> {
    const configUrl = `${this.API_URL}/savesystemsettings`;
    const result = this.http.post(configUrl, settings, { responseType: 'text' });
    return result;
  }
}
